import { createAction } from '@reduxjs/toolkit';

import type { StatsRange } from '../../_shared/domain/stats.domain';

/**
 * "Signal" actions: the intents the page dispatches for the saga. No reducers:
 * they trigger the stats poll, not a state transition (the saga owns the
 * resulting `load*` transitions).
 */

/**
 * Start (or restart) the stats poll for a period. Dispatched on mount and every
 * time the period changes: `takeLatest` cancels the running loop, so the new
 * range replaces the old one.
 */
export const statsRequested = createAction<{ range: StatsRange }>('metrics/statsRequested');
/** Stop the stats poll loop (page unmount). */
export const statsStopped = createAction('metrics/statsStopped');
